import * as React from 'react';
import { onTabButtonClick } from './FormModalProvider.logic';
import { SvgImage } from '../SvgImage';

const FormModalProviderTabButton = ({
  pageNumber,
  actualStep,
  disable,
  setActualStep,
  icon,
  title,
  onStepChange,
  testId
}) => (
  <button
    data-testid={testId || 'button'}
    type="button"
    key={`step-${pageNumber}`}
    className={`${
      actualStep === pageNumber ? 'button-active' : ''
    } text-regular`}
    onClick={event => {
      onTabButtonClick(
        event,
        actualStep,
        pageNumber,
        disable,
        setActualStep,
        onStepChange
      );
    }}
  >
    {icon && <SvgImage inAssetsPath={icon} />}
    {title}
  </button>
);

export default FormModalProviderTabButton;
